<template>
  <PublicLayout
    variant="directions"
    :breadcrumbs="breadcrumbs"
    :ui="{
      heroBreadcrumbs: 'mb-0!',
    }"
  >
    <template #hero-title>
      <div
        class="flex items-center max-md:flex-col max-md:items-start max-md:gap-5"
      >
        <span>Подобрать направление</span>
        <ClientOnly>
          <LocationBadge class="ml-5 max-md:ml-0">{{
            selectedCity?.label
          }}</LocationBadge>
        </ClientOnly>
      </div>
    </template>

    <template #hero-description>
      Выберите интересующие вас параметры, чтобы найти подходящие направления
    </template>

    <UContainer class="page-section">
      <PageSearchFilter
        v-model:directions="selectedDirections"
        v-model:query="query"
        class="-mt-28 mb-10"
        @search="search"
      />

      <ExpandableList v-slot="{ displayItems }" :items="directions" :limit="9">
        <CommonGridCards :items="displayItems" :pending="pending">
          <template #card="{ item }">
            <CommonCard
              :item="item"
              :to="`/directions/${item.id}`"
              :description-under-left="descriptionUnder"
              chip="14"
              :ui="{
                titleWrapper: 'justify-start',
                title: 'max-sm:line-clamp-1',
              }"
            >
            </CommonCard>
          </template>
        </CommonGridCards>
      </ExpandableList>
    </UContainer>

    <JoinUsSection />
  </PublicLayout>
</template>

<script setup lang="ts">
import JoinUsSection from '~/components/main-page/JoinUsSection.vue'
import ExpandableList from '~/components/ExpandableList.vue'
import PublicLayout from '~/layouts/PublicLayout.vue'
import type {
  BreadcrumbItem,
  DirectionMenuItem,
  IconWithLabel,
  SearchParams,
} from '~/types'

defineOptions({
  name: 'DirectionsPage',
})

const breadcrumbs: BreadcrumbItem[] = [
  {
    name: 'Главная',
    to: '/',
  },
  {
    name: 'Направления',
  },
]

definePageMeta({
  breadcrumbs,
})

const route = useRoute()
const directoryStore = useDirectoryStore()
const { selectedCity, directions } = storeToRefs(directoryStore)

const { untilReady } = useRegionReady()

const { pending } = await useAppAsyncData(
  `directions-${route.path}`,
  async () => {
    await untilReady()
    await Promise.all([
      directoryStore.fetchDirections(),
      directoryStore.fetchSchools(),
    ])

    return true
  },
)

const selectedDirections = ref<DirectionMenuItem[]>([])
const query = ref('')

const descriptionUnder: IconWithLabel[] = [
  {
    icon: 'i-local-graduation-cap',
    label: 'Школы: ',
    value: '44 мок',
    iconClass: '',
  },
  {
    icon: 'i-local-award',
    label: 'Тренеры: ',
    value: '24 мок',
    iconClass: 'bg-warning-light',
  },
]

const search = async (query?: SearchParams) => {
  await directoryStore.fetchDirections(query)
}
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 422px;
  --card-image-height: 240px;

  @include max-xl {
    --card-height: 358px;
    --card-image-height: 200px;
  }

  @include max-md {
    --card-height: 330px;
    --card-image-height: 160px;
  }
}
</style>
